export interface ErrorStateAction {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
}

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  actions?: ErrorStateAction[];
}

const actionButtonStyle = (variant: 'primary' | 'secondary' | 'tertiary'): React.CSSProperties => {
  if (variant === 'secondary') {
    return {
      background: 'transparent',
      color: 'var(--color-brand-primary)',
      border: '1px solid var(--color-brand-primary)',
      padding: 'var(--spacing-2) var(--spacing-4)',
      borderRadius: 'var(--radius-md)',
      cursor: 'pointer',
    };
  }
  if (variant === 'tertiary') {
    return {
      background: 'transparent',
      color: 'var(--color-text-secondary)',
      border: '1px solid var(--color-border)',
      padding: 'var(--spacing-2) var(--spacing-4)',
      borderRadius: 'var(--radius-md)',
      cursor: 'pointer',
    };
  }
  // primary (default)
  return {
    background: 'var(--color-brand-primary)',
    color: 'var(--color-text-inverse)',
    border: 'none',
    padding: 'var(--spacing-2) var(--spacing-4)',
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
  };
};

export function ErrorState({
  title = '문제가 발생했습니다',
  message = '잠시 후 다시 시도해주세요.',
  onRetry,
  actions,
}: ErrorStateProps) {
  const hasActions = (actions && actions.length > 0) || !!onRetry;

  return (
    <div
      role="alert"
      style={{
        padding: 'var(--spacing-8)',
        textAlign: 'center',
        background: 'var(--color-surface-muted)',
        border: '1px solid var(--color-danger)',
        borderRadius: 'var(--radius-lg)',
      }}
    >
      <h3 style={{ margin: 0, color: 'var(--color-danger)' }}>{title}</h3>
      <p style={{ marginTop: 'var(--spacing-2)', color: 'var(--color-text-secondary)' }}>{message}</p>
      {hasActions && (
        <div
          style={{
            marginTop: 'var(--spacing-4)',
            display: 'flex',
            gap: 'var(--spacing-2)',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              style={actionButtonStyle('primary')}
            >
              다시 시도
            </button>
          )}
          {actions?.map((action, index) => (
            <button
              key={index}
              type="button"
              onClick={action.onClick}
              style={actionButtonStyle(action.variant ?? 'secondary')}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
